import axios from "axios";
import { compress } from "../helpers/common.helper";

const apiUri = import.meta.env.GATEWAY_URI;

export default function useJournals() {
  const queryJournals = async (filter, page, limit) => {
    const reqBody = {};

    if (filter) reqBody.filter = filter;
    if (page) reqBody.page = page;
    if (limit) reqBody.limit = limit;

    const _body = compress(JSON.stringify(reqBody));

    const result = await axios.post(`${apiUri}/api/v1/journals/query`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const createJournal = async (body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(`${apiUri}/api/v1/journals`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return result.data;
  };

  const chargeJournal = async (journalId, body) => {
    const _body = compress(JSON.stringify(body));

    const result = await axios.post(
      `${apiUri}/api/v1/journals/${journalId}/charge`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const deleteChargeJournal = async (journalId) => {
    const result = await axios.delete(
      `${apiUri}/api/v1/journals/${journalId}/charge`,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  const getChargeJournal = async (journalId) => {
    const result = await axios.get(
      `${apiUri}/api/v1/journals/${journalId}/charge`,
      {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    return result.data;
  };

  return {
    queryJournals,
    createJournal,
    chargeJournal,
    deleteChargeJournal,
    getChargeJournal,
  };
}
